import styled from "styled-components"
import { palette, size, font } from "styled-theme";

export const ActionButton = styled.button`
  color: ${ palette("color", 26)};
  background-color:${ palette("color", 16)};
  border: none;
  font-size: ${size("p0")};
  font-weight: ${font("headingWeight")};
  font-family: ${font("primary")};
  text-decoration: underline;
  text-transform: ${font("headingCase")};
  
  &:hover {
    cursor: pointer;
  }
`;